import React from 'react';
import HomeCard from "./HomeCard";

const HomeSettingsContent = () => {
    return (
        <HomeCard>
            <h3 className="text-2xl font-semibold mb-6">Settings</h3>
            {/* Add settings options here */}
        </HomeCard>
    );
};

export default HomeSettingsContent;
